import React from "react";

export const CheckIconThin = ({ nameOfClass }) => (
    <svg className={nameOfClass} viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14.9675 1.59221L6.21751 10.3422C5.89207 10.6676 5.36443 10.6676 5.039 10.3422L0.87233 6.17554L2.05084 4.99703L5.62825 8.57444L13.789 0.413696L14.9675 1.59221Z" />
    </svg>
);
